// extracted by mini-css-extract-plugin
module.exports = {"mobileBackLink":"page_mobileBackLink__Hr_Zu"};